import request from "../request";

import Currency from "app/models/currency";

export const getCurrencies = () => {
  return request.get<Currency[]>("/currencies");
};
